import { TFunction } from 'i18next';
import { isString } from 'lodash';
import { ReactNode } from 'react';
import { Option, SelectOption } from 'components/Forms';

export const getTranslatedSelectOptionLabel = (
  option: SelectOption | Option,
  tFunc?: TFunction,
  tPrefixKey?: string,
): string | ReactNode => {
  if (!isString(option.label)) {
    return option.label;
  }
  if (tFunc && tPrefixKey) {
    return tFunc(`${tPrefixKey}.${option.value}`);
  }
  return option.label;
};

export const getTranslatedSelectOptionDescription = (
  option: SelectOption | Option,
  tFunc?: TFunction,
  tPrefixHintKey?: string,
): string | ReactNode => {
  if (tFunc && tPrefixHintKey) {
    return tFunc(`${tPrefixHintKey}.${option.value}`);
  }

  if ('description' in option) {
    return option.description;
  } 

  else return ''
}